/**
 * 支付管理 退款审核
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>退款审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索:">
        <el-input size="small" v-model="formInline.word" placeholder="请输入订单号模糊搜索"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="id" label="ID" width="100">
      </el-table-column>
      <el-table-column align="center" prop="orderNo" label="订单号" width="300">
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="申请时间" width="200">
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="审核时间" width="200">
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.status == -1">审核不通过</div>
          <div v-else-if="scope.row.status === 0">待审核</div>
          <div v-else-if="scope.row.status == 1">审核通过</div>
          <div v-else-if="scope.row.status == 2">审核通过已拉黑</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createUser" label="提交人" width="200">
      </el-table-column>
      <el-table-column align="center" prop="auditUser" label="审核人" width="150">
      </el-table-column>
      <el-table-column align="center" prop="remark" label="审核意见" width="200">
      </el-table-column>
      <el-table-column align="center" prop="money" label="退款金额" width="200">
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right"  min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleData(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" v-if="scope.row.status === 0" @click="handleEdit(scope.$index, scope.row)">审核</el-button>
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" v-if="editFormVisibles" :visible.sync="editFormVisibles" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForms">
        <el-form-item label="订单号" prop="orderNo">
          <el-input size="small" :disabled="title == '查看'" v-model="editForm.orderNo" auto-complete="off" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="申请时间" prop="createTime">
          <el-date-picker
            v-model="editForm.createTime"
            type="datetime" :disabled="title == '查看'"
            @change="dateChange($event, 'createTime')"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核时间" prop="updateTime">
          <el-date-picker
            v-model="editForm.updateTime"
            type="datetime" :disabled="title == '查看'"
            @change="dateChange($event, 'updateTime')"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select size="small" :disabled="title == '查看'" v-model="editForm.status" placeholder="请选择" class="userRole">
            <el-option label="审核不通过" :value="-1"></el-option>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核通过已拉黑" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交人" prop="createUser">
          <el-input size="small" :disabled="title == '查看'" v-model="editForm.createUser" auto-complete="off" placeholder="请输入提交人"></el-input>
        </el-form-item>
        <el-form-item label="审核人" prop="auditUser">
          <el-input size="small" :disabled="title == '查看'" v-model="editForm.auditUser" auto-complete="off" placeholder="请输入审核人"></el-input>
        </el-form-item>
        <el-form-item label="审核意见" prop="remark">
          <el-input size="small" :disabled="title == '查看'" v-model="editForm.remark" auto-complete="off" placeholder="请输入审核意见"></el-input>
        </el-form-item>
        <el-form-item label="退款金额" prop="money">
          <el-input size="small" :disabled="title == '查看'" v-model="editForm.money" auto-complete="off" placeholder="请输入退款金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button size="small" @click="closeDialog">取消</el-button>
          <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button> -->
        </div>
      </div>
    </el-dialog>
    
    <!-- 审核界面 -->
    <el-dialog title="审核" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rulesA">
        <el-form-item label="审核状态:" prop="status">
          <el-radio v-model="editForm.status" :label="1">通过不拉黑</el-radio>
          <el-radio v-model="editForm.status" :label="2">通过并拉黑</el-radio>
          <el-radio v-model="editForm.status" :label="-1">不通过</el-radio>
        </el-form-item>
        <el-form-item label="审核意见:" >
          <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入审核意见"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFormA('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  refundPage, appVersionAdd, appVersionEdit, vpnVipGet, vpnVipDelete, refundAudit
} from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      editFormVisibles: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {},
      // 
      // rules 表单验证
      rulesA: {
        status: [{ required: true, message: '请选择', trigger: 'blur' }],
        // opinion: [
        //   { required: true, message: "请输入角色名称", trigger: "blur" },
        // ],
      },
      rules: {
        orderNo: [
          { required: true, message: '请输入订单号', trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: '请输入审核时间', trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: '请输入添加时间', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ],
        downloadAddr: [
          { required: true, message: '请输入下载地址', trigger: 'blur' }
        ],
        delFlag: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        appCode: [{ required: true, message: '请选择应用code', trigger: 'blur' }],
        forced: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      formInline: {
        pageNo: 0,
        pageSize: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    dateChange(e, type){
      let date = new Date(e)
      let time = this.formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      this.editForm[type] = time
      console.log(this.editForm[type], 'this.editForm[type]')
    },
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
      let o = {	
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    // 获取列表
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      refundPage(parameter)
        .then(res => {
          this.loading = false
          if (res.data.success == false) {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          } else {
            this.listData = res.data.dataList
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.page
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.totalCount
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        // this.editForm = JSON.parse(JSON.stringify(row))
        this.editForm = {
          id: row.id
        }
      } else {
        this.title = '添加'
        this.editForm = {}
      }
    },
    //显示查看界面
    handleData: function(index, row) {
      this.editFormVisibles = true
      this.title = '查看'
      this.editForm = JSON.parse(JSON.stringify(row))
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.title == '添加'){
            appVersionAdd(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            appVersionEdit(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 审核
    submitFormA(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          console.log(this.editForm, 'this.editForm')
            refundAudit(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('审核失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vpnVipDelete({id: row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('套餐管理删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    
    keyUser(index, rowItem) {
      vpnVipGet({id: rowItem.id})
        .then(res => {
          this.loading = false
          if (res.data.success == false) {
            this.$message({
              type: 'info',
              message: 'res.data.msg'
            })
          }else{
            this.editFormVisible = true
            let row = res.data
            if (row != undefined && row != 'undefined') {
              this.title = '查看'
              this.editForm.id = row.id
              this.editForm.monthNum = row.monthNum
              this.editForm.priceSource = row.priceSource
              this.editForm.priceDiscount = row.priceDiscount
              this.editForm.title = row.title
              this.editForm.type = row.type
              this.editForm.px = row.px
              this.editForm.timeFlag = row.timeFlag
            }
          }
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.editFormVisibles = false
      this.editForm = {}
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/machine/auditquery.vue